import { render } from "./ClosingDialog.vue?vue&type=template&id=502634b4&scoped=true"
import script from "./ClosingDialog.vue?vue&type=script&lang=js"
export * from "./ClosingDialog.vue?vue&type=script&lang=js"

import "./ClosingDialog.vue?vue&type=style&index=0&id=502634b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Downloads\\21TCG\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502634b4"]])

export default __exports__